import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getArticleProofsByOwnerOptions } from '@/module/Author/Article/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface ArticleOwnerProofListProps {
  articleId: Id;
  userId: Id;
}

export function ArticleOwnerProofList({ articleId, userId }: ArticleOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getArticleProofsByOwnerOptions(articleId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="article"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
